import { createAction } from 'app-components/flux/core/actionHelpers';

export const initializeAchievements = createAction('INITIALIZE_ACHIEVEMENTS');

export const getAchievements = createAction('GET_ACHIEVEMENTS');
export const getAchievementsSuccess = createAction('GET_ACHIEVEMENTS_SUCCESS');
export const getAchievementsFailure = createAction('GET_ACHIEVEMENTS_FAILURE');

export const sendAchievementsEvent = createAction(
  'SEND_ACHIEVEMENT_EVENT',
  (payload) => payload,
  (payload, meta) => meta,
);
export const sendAchievementsEventSuccess = createAction('SEND_ACHIEVEMENT_EVENT_SUCCESS');
export const sendAchievementsEventFailure = createAction('SEND_ACHIEVEMENT_EVENT_FAILURE');
